// @/utils/download.js
/**
 * 通用文件下载函数（修复expiresAt未定义问题）
 * @param {string} fileUrl 远程文件地址
 * @param {string} fileName 下载后的文件名
 * @param {string} [expiresAt] 文件过期时间（可选参数，不传则不提示）
 */
export const downloadFile = (fileUrl, fileName, expiresAt) => {
  try {
    // 创建隐藏的a标签触发下载
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName; // 指定下载后的文件名
    link.target = '_blank'; // 新开窗口下载，避免阻塞主页面
    document.body.appendChild(link);
    link.click(); // 触发点击下载
    document.body.removeChild(link); // 下载后移除标签

    // 仅当传入expiresAt时才提示过期时间，避免未定义错误
    if (expiresAt) {
      console.log(`文件${fileName}开始下载，该文件将在${expiresAt}过期，请及时保存！`);
    } else {
      console.log(`文件${fileName}开始下载！`);
    }
  } catch (error) {
    console.error('文件下载失败：', error);
    throw new Error(`下载失败：${error.message || '文件链接无效'}`);
  }
};